export default {"src":"/_next/static/media/about_blur.481374b9.svg","height":910,"width":708,"blurWidth":0,"blurHeight":0};